import {Pressable, Text, StyleSheet} from "react-native";
import React from "react";
import {useDispatch} from 'react-redux';
import { FontAwesome } from '@expo/vector-icons';
import {AsyncDispatch} from "../function/functions";
import {useTheme} from "@react-navigation/native";

export default function Check(props) {
    const {check, id, onPress } = props;

    const theme = useTheme();

    const dispatch = useDispatch();

    const styles = StyleSheet.create({
        checkComplete: {
            backgroundColor: theme.colors.scheme[2]
        },
        checkIncomplete: {
            backgroundColor: 'none',
            borderWidth:2,
            borderColor: theme.colors.scheme[6]
        },
        check: {
            display: 'flex',
            alignItems:'center',
            justifyContent:'center',
            width: 32,
            height: 32,
            color: '#fff',
            fontFamily: 'Roboto-Regular',
            fontSize:16,
            borderWidth: 0,
            borderRadius: 32,
            textAlign:'center'
        }
    });
    return (
        <Pressable //complete ? [styles.check, styles.checkComplete ] : [styles.check, styles.checkIncomplete ]
            style={({pressed}) => [styles.check, (check ? styles.checkComplete : styles.checkIncomplete), {opacity: pressed ? 0.75 : 1, backgroundColor: (check ? theme.colors.scheme[2] : (pressed ? theme.colors.scheme[3] : theme.colors.scheme[4]))}]}
            onPress={onPress}
                >
            {check ? <FontAwesome style={{color:theme.colors.scheme[4]}} name={('check')} /> : null}
        </Pressable>
    );
}